/* @flow */
/* global process __webpack_public_path__ */

import 'core-js/es6'
import 'core-js/es7'

import DataHandler from 'atpjs/data_handler'
import initial from 'tve/stores/initial'
import Version from 'tve/version'
import { setEnv } from 'tve/helpers/env'

const urlToOrigin = (href: string): string => {
  const a = document.createElement('a')
  a.href = href
  return a.origin || `${a.protocol}//${a.host}`
}

// select element from data-id on script tag or given selector
let currentScript = document.currentScript
if (!currentScript) {
  // fucking IE
  const scripts = document.getElementsByTagName('script')
  currentScript = scripts[scripts.length - 1]
}

__webpack_public_path__ = urlToOrigin(currentScript.src) + __webpack_public_path__

// another fallback
const selector = currentScript.dataset ? currentScript.dataset.selector : currentScript.getAttribute('data-selector')

const apiHost = currentScript.dataset ? currentScript.dataset.apiHost : currentScript.getAttribute('data-api-host')
let rootElement = document.querySelector(selector || '#atp-widget-tve')

// create a new element, if it does not exist.
if (!rootElement) {
  rootElement = document.createElement('div')
  currentScript.parentNode.insertBefore(rootElement, currentScript.nextSibling)
}

const element = document.documentElement

import('styles/tve')
import('tve').then((module) => {
  const { initializeApp } = module

  const data = initial.set('locale', ((element && element.lang) || 'de-CH').substr(0, 2))
  initializeApp(rootElement, apiHost, DataHandler.instance(data))
})

window.atpWidgetVersions = window.atpWidgetVersions || []
window.atpWidgetVersions.push({
  name: 'tve',
  version: Version
})
